import { PlusOutlined } from '@ant-design/icons';
import { useFormItemEnabled } from '@framework/form';
import { t } from '@framework/i18n';
import { Button, Tooltip } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { IRepeatableWidget } from '../IRepeatableWidget';

export interface IAddRowButtonProps {
  widget: IRepeatableWidget;
  itemCount: number;
  onAdd: () => void;
}

/**
 * Pulsante per l'aggiunta di una nuova riga in un repeatable widget.
 */
export function AddRowButton(props: IAddRowButtonProps) {
  const { widget, itemCount, onAdd } = props;

  const repeatRule = widget.rules?.repeatableRange;

  const { enabled } = useFormItemEnabled();

  const isMax = useMemo(
    () => repeatRule?.max && repeatRule.max <= itemCount,
    [itemCount, repeatRule],
  );

  const onClickHandler = useCallback(() => {
    if (isMax) return;
    if (!enabled) return;

    onAdd();
  }, [isMax, enabled, onAdd]);

  if (widget.layout?.hideAddButton) {
    return null;
  }

  return (
    <Tooltip
      title={
        //  Se è disabilitato non mostro il tooltip
        enabled && isMax
          ? t(
              'widgets.add-row-buttton.max-options-reached',
              'Numero massimo di opzioni raggiunte',
            )
          : undefined
      }
    >
      <Button
        size="large"
        icon={<PlusOutlined aria-hidden="true" />}
        onClick={onClickHandler}
        disabled={isMax || !enabled}
      >
        {widget.layout?.buttonText ??
          t('widgets.add-row-buttton.add', 'Aggiungi')}
      </Button>
    </Tooltip>
  );
}
